const actions = {
    // General
    TXN_TRANSFER_INIT: 'TXN_TRANSFER_INIT',
    TXN_TRANSFER_SET: 'TRANSACTION_TRANSFER_SET',
    TXN_TRANSFER_STORE_ORIGINAL_QUANTITIES: 'TXN_TRANSFER_STORE_ORIGINAL_QUANTITIES',
    TXN_TRANSFER_RESET: 'TXN_TRANSFER_RESET',

    // Item Modal
    TXN_TRANSFER_OPEN_ITEM_MODAL: 'TXN_TRANSFER_OPEN_ITEM_MODAL',
    TXN_TRANSFER_CLOSE_ITEM_MODAL: 'TXN_TRANSFER_CLOSE_ITEM_MODAL',

    TXN_TRANSFER_CHANGE_QTY: 'TXN_TRANSFER_CHANGE_QTY',
    TXN_TRANSFER_CHANGE_SELECTED_ITEM_IDS: 'TXN_TRANSFER_CHANGE_SELECTED_ITEM_IDS',
    TXN_TRANSFER_REMOVE_TRANSACTION_ID: 'TXN_TRANSFER_REMOVE_TRANSACTION_ID',

    TXN_TRANSFER_GET_ITEM_MODAL_DATA_REQUEST: 'TXN_TRANSFER_GET_ITEM_MODAL_DATA_REQUEST',
    TXN_TRANSFER_GET_ITEM_MODAL_DATA_SUCCESS: 'TXN_TRANSFER_GET_ITEM_MODAL_DATA_SUCCESS',
    TXN_TRANSFER_GET_ITEM_MODAL_DATA_ERROR: 'TXN_TRANSFER_GET_ITEM_MODAL_DATA_ERROR',

    // Transaction Modal
    TXN_TRANSFER_OPEN_TXN_MODAL: 'TXN_TRANSFER_OPEN_TXN_MODAL',
    TXN_TRANSFER_CLOSE_TXN_MODAL: 'TXN_TRANSFER_CLOSE_TXN_MODAL',

    TXN_TRANSFER_CHANGE_SELECTED_TRANSACTION_IDS: 'TXN_TRANSFER_CHANGE_SELECTED_TRANSACTION_IDS',

    // General
    init: (originType, transactionType) => ({
        type: actions.TXN_TRANSFER_INIT,
        originType,
        transactionType,
    }),
    set: data => ({
        type: actions.TXN_TRANSFER_SET,
        data,
    }),
    reset: () => ({
        type: actions.TXN_TRANSFER_RESET,
    }),

    // Item Modal
    openItemModal: () => ({
        type: actions.TXN_TRANSFER_OPEN_ITEM_MODAL,
    }),
    closeItemModal: () => ({
        type: actions.TXN_TRANSFER_CLOSE_ITEM_MODAL,
    }),
    changeQuantity: (transactionId, transactionItemId, quantity) => ({
        type: actions.TXN_TRANSFER_CHANGE_QTY,
        transactionId,
        transactionItemId,
        quantity,
    }),
    changeSelectedItemIds: (transactionId, selectedItemIds) => ({
        type: actions.TXN_TRANSFER_CHANGE_SELECTED_ITEM_IDS,
        transactionId,
        selectedItemIds,
    }),
    removeTransactionId: transactionId => ({
        type: actions.TXN_TRANSFER_REMOVE_TRANSACTION_ID,
        transactionId,
    }),

    // Transaction Modal
    openTxnModal: () => ({
        type: actions.TXN_TRANSFER_OPEN_TXN_MODAL,
    }),
    closeTxnModal: () => ({
        type: actions.TXN_TRANSFER_CLOSE_TXN_MODAL,
    }),
    changeSelectedTransactionIds: (oldIds, newIds) => ({
        type: actions.TXN_TRANSFER_CHANGE_SELECTED_TRANSACTION_IDS,
        oldIds,
        newIds,
    }),

};
export default actions;
